
define('text!areas/home/views/tiles/part-2x1-nodata.template.html',[],function () { return '<div class="nodata">\r\n\t<div class="fa fa-icon fa-fw fa-4x tile-icon fa-truck gray-text"></div>\r\n\t<div class="text gray-text" data-i18n="app:modules.home.info_noData2">Keine Daten</div>\r\n</div>\r\n';});

